
import { useState, useEffect } from 'react'
import { getMUICache, getUrl, appendStyleSheet, getEndpoint, getSocialClassName, getImageUrl, getImageSize, convertEpochTime, isImageSizeBlank, GetFallBackImage, fetchAnchorValue, GetIconsSprites } from "../../../common/utils";

import { CacheProvider } from '@emotion/react';
import bcrypt from 'bcryptjs-react';
import './FooterThree.css';
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import Link from '@mui/material/Link';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../../components/IntersectionObserver/imageComponent';
import { PAGEBUILDER_URLS } from '../../Common/Constant';
// import {EagerLoadImages, AddImageDimensions, SetHighPriorityImages  } from '../../../components/IntersectionObserver/imageComponent';

FooterThree.version = 1000;

FooterThree.lang = 'en';
FooterThree.langs = [
    'en'
];
FooterThree.setLang = (lang: any) => {
    FooterThree.lang = lang;
}

Object.defineProperty(FooterThree, 'name', {
    writable: true,
    value: 'FooterThree'
});

// Define a type for the fetch options
interface FetchOptions {
    method: string;
    headers: {
        'Content-Type': string;
        'p-nonce': string;
    };
    credentials?: RequestCredentials; // Use RequestCredentials type
}

export function FooterThree(props: any) {
    AddImageDimensions();
    SetHighPriorityImages();
    PreloadViewportImages();
    ImageLoader();

        useEffect(()=>{
            EagerLoadImages()
        },[]);

    const [menuItems, setMenuItems] = useState<any[]>([]);
    const [footerData, setFooterData] = useState<any>({});
    const [footerSyoryItems, setFooterSyoryItems] = useState<any>({});

    const cache = getMUICache();
    const { showStaticPages, showSocialIcons, copyRightText, BgColor, TextColor, TitleText, showAbout, noOfHeaderItems, anchorLinksValue } = props;


    let styles = require("./FooterThree.css");
    appendStyleSheet("FooterThree", styles);
    const endpoint = getEndpoint(props, "MAIN");
    const footerMenuEndpoint = getEndpoint(props, "FOOTER_MENU_API");
    const footerStories = getEndpoint(props, "HEADER_DATA");
    useEffect(() => {
        if (!endpoint?.isSSR || !endpoint?.SSRDataObj || !footerMenuEndpoint?.isSSR || !footerMenuEndpoint?.SSRDataObj || !footerStories?.isSSR || !footerStories?.SSRDataObj) {
            fetchComponentData();
        }
    }, [endpoint, footerMenuEndpoint, footerStories, showAbout]);

    useEffect(() => {
        if (endpoint?.isSSR && endpoint?.SSRDataObj && (!footerSyoryItems || !Object.keys(footerSyoryItems).length)) {
            setFooterSyoryItems(endpoint?.SSRDataObj);
        }
    }, [endpoint?.SSRDataObj]);

    useEffect(() => {
        if (footerMenuEndpoint?.isSSR && footerMenuEndpoint?.SSRDataObj && footerMenuEndpoint?.SSRDataObj.length && (!menuItems || !menuItems.length)) {
            setMenuItems(footerMenuEndpoint?.SSRDataObj);
        }
    }, [footerMenuEndpoint?.SSRDataObj]);

    useEffect(() => {
        if (footerStories?.isSSR && footerStories?.SSRDataObj && (!footerData || !footerData.length)) {
            setFooterData(footerStories?.SSRDataObj);
        }
    }, [footerStories?.SSRDataObj]);

    const fetchComponentData = () => {
        const { ENDPOINTS } = props;

        let footerAPI = getUrl(props, 0, false, "HEADER_DATA", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId);
        let menuAPIurl = getUrl(props, 0, false, "FOOTER_MENU_API", true);
        let footerStoryAPIurl = getUrl(props, 1, false, "MAIN", false);


        let headerString = `?` + footerAPI.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const customHeaders = {
            'Content-Type': 'application/json',
            'p-nonce': headerString
        };
        var fetchOptions: FetchOptions = {
            method: 'GET',
            headers: customHeaders
        };


        let footerString_storyAPIurl = '?' + footerStoryAPIurl.split("?")[1];
        footerString_storyAPIurl = bcrypt.hashSync(footerString_storyAPIurl, 6);
        const footer_storyAPIurl = { 'p-nonce': footerString_storyAPIurl };


        let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
        headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
        const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

        if (footerAPI.includes('getsiteResources') && !footerAPI.includes("rendering/getsiteResources") &&
            (typeof document !== 'undefined' && undefined !== document && document
                && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)))) {
            footerAPI = footerAPI.replace("getsiteResources", "rendering/getsiteResources");
        } else { fetchOptions.credentials = "include"; }
        Promise.all([
            fetch(footerAPI, fetchOptions).then((response) => response.json()),
            fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
            fetch(footerStoryAPIurl, { headers: footer_storyAPIurl }).then((response) => response.json())
        ])
            .then(([result1, result2, result3]) => {
                // Handle the results individually
                setFooterData(result1);
                setMenuItems(Array.isArray(result2) ? result2 : []);
                setFooterSyoryItems(result3)


            })
            .catch((error) => {
                // Handle errors here
                console.error('Error fetching data:', error);
            });
    }


    const renderStaticPages = () => {
        if (!footerData.staticPages) {
            return false;
        }
        let listItems = footerData.staticPages.map((val: any, index: number) => {
            return <li key={'ff_' + index} ><a href={val.sourcePath} target={fetchAnchorValue(anchorLinksValue, val.sourcePath)} style={{ color: TextColor }}>{val["name"]}</a></li>
        })
        return (<ul>{listItems}</ul>)
    }


    const getMenuItems = () => {
        if (!Array.isArray(menuItems)) {
            return null;
        }

        let menuData = menuItems.slice(0, noOfHeaderItems);

        return <ul>
            {menuData && menuData?.map((val: any, i: any) => {
                let morePath: string = val.path;
                if (val.type === 2) {
                    morePath = '/tags/' + (val.tagpath !== undefined ? val.tagpath : '');
                }
                return <li className='nav-item' key={i}><a className='navlink' href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)} style={{ color: TextColor }}>{val.name}</a></li>
            })
            }
        </ul>

    }

    const renderSocialIcons = () => {
        if (!footerData.socialPlatformList) {
            return false;
        }
        let html = <div className="ThemeThreeFooterSocialMediaMapWrap">
            <ul className='ThemeThreeFooterSocialMedia'>
                {footerData?.socialPlatformList.filter((item: any) => item.url.trim() !== '').map((val: any, i: any) => {
                    let iconType = getSocialClassName(val.name, 3);
                    return <li key={i}><a key={i} href={val.url} target="_blank" aria-label="social shares">

                        {/* <FoontAwesomeIcon icon={iconType} /> */}
                        <div className={`sprite-icon ${iconType}`} style={{ backgroundImage: `url(${GetIconsSprites()})` }} />

                    </a></li>
                })
                }
            </ul>
        </div>
        return html;

    }

    return (
        <div className='ThemeThereeFooter' style={{ backgroundColor: BgColor }}>
            <CacheProvider value={cache}>
                <div className='GridSystemWrapper'>
                    <div className='GridSystemFooter'>
                        <div className='themeThreeFooterWrapper'>
                            <div className='ThemeThreeFooterLogoWrap'>
                                <a href="/" aria-label="logo" target="_self" className="main-logo">
                                    {footerData.footerLogo && <img src={getImageUrl(footerData.footerLogo, "422424", 96, undefined, "", false, props.CONSTANTS)} alt="logo" title="logo" width="96" height="36" />}
                                </a>
                            </div>
                            <div className='ThemeThreefooterDiscription'>
                                {props.showAbout && <p style={{ color: TextColor }}>{footerData && footerData?.aboutSiteContent}</p>}
                            </div>
                            <div className='ThemeThreeFooterSocialWrap'>
                                {showSocialIcons && renderSocialIcons()}
                            </div>
                        </div>
                    </div>

                    <div className='GridSystemFooter'>
                        <div className='footerAdressWrapper'>
                            <div className='ThemeThreeFooterHeading' style={{ color: TextColor }}>Contact</div>
                            <ul className='ThemeThreeFooterAdressWrap'>
                                <li>
                                    <FmdGoodOutlinedIcon /><span style={{ color: TextColor }}>{footerData && footerData?.contactUs}</span>
                                </li>
                                <li>
                                    <MailOutlinedIcon />
                                    <a href={`mailto:${props.supportEmail}`} style={{ color: TextColor }}>{footerData && footerData?.supportEmail}</a>
                                    {/* <a href={props.supportEmail ? `mailto:${props.supportEmail}` : '#'} style={{ color: TextColor }}>
                                        {footerData && footerData.supportEmail ? footerData.supportEmail : "support@example.com"}
                                    </a> */}
                                </li>
                                <li>
                                    <CallRoundedIcon /><a href={props.supportEmail} style={{ color: TextColor }}>{footerData && footerData?.supportEmail}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='GridSystemFooter'>
                        <div className='ThemeThreeFooterLinksWrap'>
                            <div className='ThemeThreeMenuLinks'>
                                <div className='ThemeThreeFooterHeading' style={{ color: TextColor }}>Menu</div>
                                {menuItems && getMenuItems()}
                            </div>
                        </div>
                    </div>
                    <div className='GridSystemFooter'>
                        <div className='footerAdressWrapper'>
                            <div className='ThemeThreeFooterHeading' style={{ color: TextColor }}>{TitleText}</div>
                            <div className='ThemeThreeFooterRecentMainWrap'>
                                {footerSyoryItems && Array.isArray(footerSyoryItems?.items) && footerSyoryItems?.items.map((val: any, index: number) => {
                                    if (index < 2) {
                                        return <Link href={val.wu} key={'footerstory_' + index} className='ThemeThreeFooterRecentWrap' target={fetchAnchorValue(anchorLinksValue, val.wu)}>
                                            <div className='ThemeThreeRecentImageWrap'>

                                                {isImageSizeBlank(val.imageid) ? <picture>
                                                    <source media="(min-width: 768px)" srcSet={getImageUrl(val.id, getImageSize(val.imageid), 98, '', "", false, props.CONSTANTS , '3')} />
                                                    <source media="(max-width: 767px)" srcSet={getImageUrl(val.id, getImageSize(val.imageid), 98, '', "", false, props.CONSTANTS, '3')} />
                                                    <img alt={val?.hl.substring(0, 25) ?? ''} title={val?.hl.substring(0, 25) ?? ''} loading="lazy"/>
                                                </picture> : <img src={GetFallBackImage()} alt={val?.hl.substring(0, 25) ?? ''} title={val?.hl.substring(0, 25) ?? ''} loading="lazy" />}

                                            </div>
                                            <div className='ThemeThreeRecentContent'>
                                                <p className='RecentShortText' style={{ color: TextColor }}>{val.hl}</p>
                                                <div className='RecentTimeWrap'>
                                                    <p>{convertEpochTime(val.lpt, 'updated', "DD MMM YYYY")}</p>
                                                </div>
                                            </div>
                                        </Link>
                                    }
                                }

                                )}

                            </div>
                        </div>
                    </div>
                </div>
                <div className='ThemeThreeBottomFooter'>
                    <div className='ThemeThreeCopyRightWrap'> <p className='ThemeThreeCopyRightText'>{copyRightText ? copyRightText : footerData.copyRightContent}</p></div>
                    <div className='ThemeThreeStaticLinkWrap'>
                        {showStaticPages && renderStaticPages()}
                    </div>
                </div>
            </CacheProvider>
        </div>

    )

}

